// Created by PeakXin on 2025/10/29.
import { getToken as getApiToken, verifyToken as verifyApiToken } from '@/api/token'
import { logout, getUserInfo, getAgentInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/wxauth'

const state = {
  token: getToken(),
  userInfo: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  }
}

const actions = {
  // 获取登录Token
  getToken({ commit }, data) {
    const { code, state } = data
    return new Promise((resolve, reject) => {
      console.log(code, state)
      getApiToken({ code: code, state: state })
        .then(response => {
          const { data } = response
          // 设置store中的token
          commit('SET_TOKEN', data.token)
          // 设置cookie中的token
          setToken(data.token)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 验证Token是否有效
  validateToken({ state }) {
    return new Promise((resolve, reject) => {
      verifyApiToken(state.token)
        .then(response => {
          const { data } = response
          if (!data.isValid) {
            reject('Token已过期，请重新登录')
          }
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取用户信息
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getUserInfo()
        .then(response => {
          const { data } = response
          console.log('用户信息', data)
          if (!data) {
            reject('验证失败，请重新登录')
          }
          commit('SET_USER_INFO', data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取代理商用户信息
  getAgent({ commit }) {
    return new Promise((resolve, reject) => {
      getAgentInfo()
        .then(response => {
          const { data } = response
          console.log('用户信息', data)
          if (!data) {
            reject('验证失败，请重新登录')
          }
          commit('SET_USER_INFO', data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 用户登出
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          // 清除store中的token和用户信息
          commit('SET_TOKEN', '')
          commit('SET_USER_INFO', {})
          // 清除cookie中的token
          removeToken()
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 清除Token
  resetToken({ commit }) {
    return new Promise(resolve => {
      // 清除store中的token和用户信息
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', {})
      // 清除cookie中的token
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
